import { render, staticRenderFns } from "./AoikumoOutletTag.vue?vue&type=template&id=8557f8a4&"
import script from "./AoikumoOutletTag.vue?vue&type=script&lang=js&"
export * from "./AoikumoOutletTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8557f8a4')) {
      api.createRecord('8557f8a4', component.options)
    } else {
      api.reload('8557f8a4', component.options)
    }
    module.hot.accept("./AoikumoOutletTag.vue?vue&type=template&id=8557f8a4&", function () {
      api.rerender('8557f8a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/dahreply/AoikumoOutletTag.vue"
export default component.exports